import { useBaseApiMutation } from "@mutation/baseMutation";

export const usePostUpdateMutation = (postUuid) =>{

    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: `/organization/me/post/${postUuid}`
        }
    )
}

export const usePostDeleteMutation = (postUuid) =>{

    return useBaseApiMutation(
        {
            method: "DELETE",
            endpoint: `/organization/me/post/${postUuid}`
        }
    )
}

export const usePostClubCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/club/{club_uuid}/post`
        }
    )
}

export const usePostSiteCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/site/{site_uuid}/post`
        }
    )
}

